/* eslint-disable max-len */

const getLanding = (endpoint) => {
  const landingsMatcher = endpoint.match(/.*\/(es|pt|en)\/docs(\/)?(?<landing>online-payments|in-person-payments|overview|plugins|sdks)?\/?($|\?)/);
  let landing = null;
  if (landingsMatcher) {
    landing = landingsMatcher.groups.landing ? landingsMatcher.groups.landing : 'home';
  }
  return landing;
};

module.exports = { getLanding };
